__turbopack_context__.v({
  "footerContent": "Footer-module-scss-module__wcgw9G__footerContent",
  "footerNav": "Footer-module-scss-module__wcgw9G__footerNav",
  "listingsFooter": "Footer-module-scss-module__wcgw9G__listingsFooter",
});
